import styled from "styled-components/native";

const StyledWrapper = styled.View`
	z-index: -1;
	margin: 180px 14.1% 0 14.1%;
`;

// @ts-ignore
const DeviceNameContainer = ({ children }) => {
	return (
		// @ts-ignores
		<StyledWrapper>{children}</StyledWrapper>
	);
};

export default DeviceNameContainer;
